<div class="axs-flex-inner-wrapper pad-top-12 pad-bottom-12 column-gap-16">
  <div class="axs-flex--col axs-lg-offset-left-1" style="width: 320px">
    <div class="text-title-1 margin-bottom-4 paragraph-header">
      {{ howItWorksContent?.title }}
    </div>
    <div class="text-body-2 margin-bottom-5 paragraph-body">
        <span
          [innerHTML]="howItWorksContent?.description"></span>
        <a class="link"
              (click)="onOpenBreakEvenTaxRate()">
         {{ howItWorksContent?.breakEvenTaxRate }}</a>
        <span>{{ howItWorksContent?.betr }}</span>
    </div>

    <div class="tool-section">
      <ngx-axs-button [axsType]="'primary'" [axsText]="howItWorksContent?.calculatorButton" [axsTheme]="'vg-red'"
                      (axsClick)="onUseCalculator()">
      </ngx-axs-button>

      <ngx-axs-button [axsType]="'primary'" [axsText]="howItWorksContent?.sampleClientButton"
                      [axsTheme]="'black-outline'" (axsClick)="onTrySampleClient()">
      </ngx-axs-button>
    </div>

    <div class="walkthrough-animation">
      <img src="assets/images/introduction-modal/RCC-Walkthrough-1.gif" alt="Roth Conversion Calculator Animation"/>
    </div>
  </div>

  <!-- Need help section -->
  <div class="axs-flex--col axs-lg-offset-right-1" style="width: 320px">
    <div class="text-title-1 margin-bottom-4 paragraph-header">
      {{ needHelpContent?.need_help }}
    </div>
    <div class="text-body-2 margin-bottom-8 paragraph-body">
      {{ needHelpContent?.disc }}
    </div>

    <!-- BETR Section -->
    <div class="text-body-2 instructions-text paragraph-body">
      <ngx-axs-icon class="red-icon" axsType="arrowRight" axsTitle="arrow right icon" axsWidth="20"
      ></ngx-axs-icon>
      <span><strong>{{ needHelpContent?.betr_header }}</strong></span>
    </div>
    <div class="text-body-2 margin-bottom-2 paragraph-body section-description">
      {{ needHelpContent?.betr_disc }}
    </div>
    <div class="text-body-2 margin-bottom-2 section-link-indent">
      <a class="link" (click)="downloadResearch()">
        {{ needHelpContent?.summery_link }}
      </a>
    </div>
    <div class="text-body-2 margin-bottom-8 section-link-indent">
      <a class="link" [href]="researchPaperLink" (click)="openResearchPaper($event)">
        {{ needHelpContent?.research_link }}
      </a>
    </div>

    <!-- Terms and Definitions Section -->
    <div class="text-body-2 instructions-text paragraph-body">
      <ngx-axs-icon class="red-icon" axsType="arrowRight" axsTitle="arrow right icon" axsWidth="20"
      ></ngx-axs-icon>
      <span><strong>{{ needHelpContent?.terms }}</strong></span>
    </div>
    <div class="text-body-2 margin-bottom-2 paragraph-body section-description">
      {{ needHelpContent?.terms_disc }}
    </div>
    <div class="text-body-2 margin-bottom-8 section-link-indent">
      <a class="link" (click)="onViewTermsAndDefinitions()">
        {{ needHelpContent?.terms_link }}
      </a>
    </div>

    <!-- Tax Charts Section -->
    <div class="text-body-2 instructions-text paragraph-body">
      <ngx-axs-icon class="red-icon" axsType="arrowRight" axsTitle="arrow right icon" axsWidth="20"
      ></ngx-axs-icon>
      <span><strong>{{ needHelpContent?.tax_header }}</strong></span>
    </div>
    <div class="text-body-2 margin-bottom-2 paragraph-body section-description">
      {{ needHelpContent?.tax_disc }}
    </div>
    <div class="text-body-2 section-link-indent">
      <a class="link" [href]="taxChartLink" (click)="openTaxChart($event)">
        {{ needHelpContent?.tax_link }}
      </a>
    </div>
  </div>
</div>


<research-summary-modal
  [(isOpen)]="isResearchSummaryModalOpen"
></research-summary-modal>
